// eslint-disable-next-line import/prefer-default-export
export const API_URL = process.env.REACT_APP_API_URL;
export const DD_CLIENT_TOKEN = process.env.REACT_APP_DD_CLIENT_TOKEN;